import 'bootstrap/dist/css/bootstrap.css';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';




import { ThemeProvider } from './context/ThemeContext';
import { ToastProvider } from './context/ToastContext';
import './i18n';
import React, { Suspense } from 'react';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ThemeProvider>
    <ToastProvider>
      <Suspense fallback={<div>Loading translations...</div>}>
        <App />
      </Suspense>
    </ToastProvider>
  </ThemeProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
